var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":_vm.productImage,"width":"100%"},on:{"error":_vm.onError}})
}
var staticRenderFns = []

export { render, staticRenderFns }